<template>
    <el-dialog :title="title" width="40%" :close-on-click-modal="false" append-to-body :visible.sync="visible">
        <el-form size="small" :model="form" ref="form" label-width="140px" :rules="dataRule" v-loading="loading"
                 :disabled="method==='view'" @keyup.enter.native="doSubmit()" @submit.native.prevent>
            <el-form-item label="功能标识ID：" prop="fonctionsNumber">
                <el-input v-model.trim="form.fonctionsNumber" placeholder="请输入功能标识ID（限100字）" clearable maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="功能名称：" prop="fonctionsName">
                <el-input v-model.trim="form.fonctionsName" placeholder="请输入功能名称（限50字）" clearable maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="功能类型：" prop="detailType">
                <el-select class="w100i" v-model="form.detailType" placeholder="请选择功能类型" clearable>
                    <el-option
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            v-for="item in $dictUtils.getDictList('detailType')">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="操作条件设置：" prop="operateType">
                <el-radio-group v-model="form.operateType">
                    <el-radio label="0">支持</el-radio>
                    <el-radio label="1">不支持</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="资源状态变更：" prop="changeType">
                <el-radio-group v-model="form.changeType">
                    <el-radio label="0">是</el-radio>
                    <el-radio label="1">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="状态：" prop="disabled">
                <el-switch v-model="form.disabled" active-value="0" inactive-value="1"></el-switch>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
                loading: false,
                title: '',
                method: '',
                form: {
                    fonctionsNumber: '',
                    fonctionsName: '',
                    detailType: '',
                    operateType: '0',
                    changeType: '0',
                    disabled: '0',
                },
                dataRule: {
                    fonctionsNumber: [
                        {required: true, message: '功能标识ID不能为空', trigger: 'blur'}
                    ],
                    fonctionsName: [
                        {required: true, message: '功能名称不能为空', trigger: 'blur'}
                    ],
                    operateType: [
                        {required: true, message: '操作条件设置不能为空', trigger: 'change'}
                    ],
                    changeType: [
                        {required: true, message: '资源状态变更不能为空', trigger: 'change'}
                    ],
                }
            }
        },
        methods: {
            init(row, method) {
                this.method = method
                if (method === 'add') {
                    this.title = `新增`
                } else if (method === 'edit') {
                    this.title = '修改'
                } else if (method === 'view') {
                    this.title = '查看'
                }
                if (row) {
                    this.form.id = row.id
                } else {
                    this.form.id = ''
                }
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.form.resetFields();
                    if (row) {
                        this.form = this.recover(this.form, row);
                    }
                })
            },
            // 确定
            doSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.$axios(this.api.metadata.metadatafonctionsSave, this.form, 'post').then(data => {
                            if (data.status) {
                                this.$message.success('操作成功')
                                this.visible = false
                                this.$emit('refreshDataList')
                            } else {
                                this.$message.error(data.msg)
                            }
                            this.loading = false
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .el-icon-question {
        margin-left: 6px;
        font-size: 16px;
        cursor: pointer;
    }

    .textarea {
        white-space: pre-wrap;
    }

    .rangeBox {
        max-height: calc(100vh - 372px);
        overflow-y: auto;
        padding-right: 10px;
    }
</style>
